<template>
  <div class="container-fluid vertical-spacing level4-forms">
    <div class="row around-sm middle-xs">
      <div class="col-xs-12 col-sm-5">
        <SearchByVin />
        <SearchByFilters />
      </div>
      <div class="col-xs-12 col-sm-2">
        {{ $t('or') }}
      </div>
      <div class="col-xs-12 col-sm-5">
        <SearchByParts />
      </div>
    </div>
  </div>
</template>

<script>
import SearchByVin from './SearchByVin.vue';
import SearchByParts from './SearchByParts.vue';
import SearchByFilters from './SearchByFilters.vue';

export default {
  name: 'Level4Forms',
  components: {
    SearchByVin,
    SearchByParts,
    SearchByFilters,
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers";
@import "src/scss/_breakpoint";

.row .col-xs-12:nth-child(2) {
  text-align: center;
}

</style>
